
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';
import defaultThumbnail from '@/image/222f192d71a8fa1eadce8b0d0cb7b76c.jpg';
export default function MatchDetail() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [match, setMatch] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<string>('overview');
  const [showSetReminder, setShowSetReminder] = useState(false);

  // 扩展的赛事数据
  const extendedMatches = [
    {
      id: 1,
      title: '巴塞罗那 vs 皇家马德里',
      category: '足球',
      league: '西甲',
      status: 'upcoming',
      time: '今天 22:00',
      date: new Date().toLocaleDateString('zh-CN'),
      venue: '诺坎普球场',
      capacity: '99,354',
      importance: 'high',
      description: '西甲国家德比大战，巴塞罗那主场迎战皇家马德里，这是西班牙足球最高水平的对决。',
      homeTeam: '巴塞罗那',
      awayTeam: '皇家马德里',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Barcelona%20vs%20Real%20Madrid%20El%20Clasico%20football%20match%20Camp%20Nou%20stadium%20atmosphere%20with%20dramatic%20lighting%20and%20passionate%20fans&width=800&height=400&seq=matchdetail1&orientation=landscape',
      referee: '安东尼奥·马特乌·拉奥斯',
      weather: '晴朗，20°C',
      tickets: '已售罄',
      ticketPrice: '€50-€200',
      broadcastInfo: {
        tv: ['ESPN', 'Sky Sports', 'CCTV5'],
        streaming: ['ESPN+', 'Barca TV', 'Real Madrid TV']
      },
      predictions: {
        homeWin: 40,
        draw: 30,
        awayWin: 30
      },
      recentForm: {
        home: ['胜', '胜', '平', '胜', '负'],
        away: ['胜', '平', '胜', '胜', '胜']
      },
      headToHead: '近5次交锋：巴塞 2胜1平2负 皇马',
      keyPlayers: {
        home: [
          { name: '梅西', position: '前锋', goals: 25, assists: 12 },
          { name: '德容', position: '中场', goals: 6, assists: 8 },
          { name: '特尔施特根', position: '门将', saves: 95, cleanSheets: 18 }
        ],
        away: [
          { name: '本泽马', position: '前锋', goals: 22, assists: 9 },
          { name: '莫德里奇', position: '中场', goals: 4, assists: 15 },
          { name: '库尔图瓦', position: '门将', saves: 88, cleanSheets: 16 }
        ]
      },
      teamStats: {
        home: {
          formation: '4-3-3',
          possession: 62,
          shots: 18.5,
          corners: 7.2,
          fouls: 10.8,
          cards: { yellow: 2.0, red: 0.1 }
        },
        away: {
          formation: '4-3-3',
          possession: 58,
          shots: 16.8,
          corners: 6.5,
          fouls: 11.5,
          cards: { yellow: 2.2, red: 0.1 }
        }
      },
      injuries: {
        home: [
          { name: '佩德里', injury: '肌肉拉伤', status: '疑似' }
        ],
        away: [
          { name: '阿拉巴', injury: '膝盖伤势', status: '确定缺席' }
        ]
      },
      news: [
        {
          title: '哈维：国家德比是足球的盛宴',
          time: '1小时前',
          summary: '巴塞罗那主教练在赛前发布会上表示球队已经准备好迎接挑战...'
        },
        {
          title: '安切洛蒂：皇马有信心客场取胜',
          time: '3小时前',
          summary: '皇家马德里主帅强调球队状态良好，有信心在诺坎普取得好结果...'
        },
        {
          title: '国家德比：两队积分差距仅有2分',
          time: '5小时前',
          summary: '联赛积分榜显示两队积分非常接近，本场比赛对争冠形势至关重要...'
        }
      ]
    },
    {
      id: 2,
      title: '湖人 vs 勇士',
      category: '篮球',
      league: 'NBA',
      status: 'upcoming',
      time: '明天 09:00',
      date: new Date(Date.now() + 86400000).toLocaleDateString('zh-CN'),
      venue: '斯台普斯中心',
      capacity: '20,000',
      importance: 'high',
      description: 'NBA西部强强对话，洛杉矶湖人主场迎战金州勇士，两支历史悠久的球队再次碰撞。',
      homeTeam: '洛杉矶湖人',
      awayTeam: '金州勇士',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Lakers%20vs%20Warriors%20NBA%20basketball%20game%20Staples%20Center%20arena%20atmosphere%20with%20purple%20and%20gold%20vs%20blue%20and%20yellow%20team%20colors&width=800&height=400&seq=matchdetail2&orientation=landscape',
      referee: '斯科特·福斯特',
      weather: '室内比赛',
      tickets: '少量余票',
      ticketPrice: '$75-$500',
      broadcastInfo: {
        tv: ['ESPN', 'TNT', '腾讯体育'],
        streaming: ['NBA League Pass', '腾讯视频']
      },
      predictions: {
        homeWin: 55,
        draw: 0,
        awayWin: 45
      },
      recentForm: {
        home: ['胜', '负', '胜', '胜', '胜'],
        away: ['胜', '胜', '平', '负', '胜']
      },
      headToHead: '近5次交锋：湖人 3胜2负 勇士',
      keyPlayers: {
        home: [
          { name: '勒布朗·詹姆斯', position: '前锋', goals: 28, assists: 8 },
          { name: '安东尼·戴维斯', position: '中锋', goals: 24, assists: 3 },
          { name: '拉塞尔·威斯布鲁克', position: '后卫', goals: 18, assists: 7 }
        ],
        away: [
          { name: '斯蒂芬·库里', position: '后卫', goals: 32, assists: 6 },
          { name: '克莱·汤普森', position: '后卫', goals: 22, assists: 4 },
          { name: '德雷蒙德·格林', position: '前锋', goals: 8, assists: 9 }
        ]
      },
      teamStats: {
        home: {
          formation: '小球阵容',
          possession: 52,
          shots: 95.5,
          corners: 0,
          fouls: 18.2,
          cards: { yellow: 0, red: 0 }
        },
        away: {
          formation: '快攻体系',
          possession: 48,
          shots: 98.3,
          corners: 0,
          fouls: 17.8,
          cards: { yellow: 0, red: 0 }
        }
      },
      injuries: {
        home: [],
        away: [
          { name: '安德鲁·维金斯', injury: '脚踝扭伤', status: '疑似' }
        ]
      },
      news: [
        {
          title: '詹姆斯：我们准备好在主场战斗',
          time: '2小时前',
          summary: '湖人核心球员表示球队状态很好，期待在主场球迷面前展现实力...'
        },
        {
          title: '库里三分球训练状态火热',
          time: '4小时前',
          summary: '勇士当家球星在训练中三分球命中率极高，为比赛做好充分准备...'
        }
      ]
    },
    {
      id: 101,
      title: '拜仁慕尼黑 vs 多特蒙德',
      category: '足球',
      league: '德甲',
      status: 'upcoming',
      time: '今天 20:30',
      date: new Date().toLocaleDateString('zh-CN'),
      venue: '安联球场',
      capacity: '75,000',
      importance: 'high',
      description: '德甲榜首大战，两队积分接近，这场比赛将直接影响联赛冠军归属。拜仁慕尼黑坐镇主场迎战死敌多特蒙德，这是一场不容错过的精彩对决。',
      homeTeam: '拜仁慕尼黑',
      awayTeam: '多特蒙德',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Bayern%20Munich%20vs%20Borussia%20Dortmund%20football%20match%20stadium%20atmosphere%2C%20professional%20sports%20photography%20with%20dramatic%20lighting%20and%20crowd&width=800&height=400&seq=matchdetail101&orientation=landscape',
      referee: '费利克斯·茨瓦耶尔',
      weather: '晴朗，18°C',
      tickets: '已售罄',
      ticketPrice: '€45-€180',
      broadcastInfo: {
        tv: ['ESPN', 'Sky Sports', 'CCTV5'],
        streaming: ['ESPN+', 'Bayern TV', 'BVB TV']
      },
      predictions: {
        homeWin: 45,
        draw: 30,
        awayWin: 25
      },
      recentForm: {
        home: ['胜', '胜', '平', '胜', '负'],
        away: ['胜', '胜', '胜', '平', '胜']
      },
      headToHead: '近5次交锋：拜仁 2胜2平1负 多特',
      keyPlayers: {
        home: [
          { name: '穆勒', position: '前锋', goals: 12, assists: 8 },
          { name: '莱万多夫斯基', position: '前锋', goals: 28, assists: 4 },
          { name: '诺伊尔', position: '门将', saves: 89, cleanSheets: 15 }
        ],
        away: [
          { name: '哈兰德', position: '前锋', goals: 24, assists: 6 },
          { name: '罗伊斯', position: '中场', goals: 8, assists: 12 },
          { name: '贝林厄姆', position: '中场', goals: 6, assists: 10 }
        ]
      },
      teamStats: {
        home: {
          formation: '4-2-3-1',
          possession: 58,
          shots: 16.2,
          corners: 6.8,
          fouls: 11.4,
          cards: { yellow: 2.1, red: 0.1 }
        },
        away: {
          formation: '4-3-3',
          possession: 52,
          shots: 14.8,
          corners: 5.4,
          fouls: 12.2,
          cards: { yellow: 2.3, red: 0.2 }
        }
      },
      injuries: {
        home: [
          { name: '戴维斯', injury: '膝盖伤势', status: '疑似' },
          { name: '科曼', injury: '肌肉拉伤', status: '确定缺席' }
        ],
        away: [
          { name: '胡梅尔斯', injury: '背部不适', status: '疑似' }
        ]
      },
      news: [
        {
          title: '拜仁主帅：这是决定冠军归属的关键一战',
          time: '2小时前',
          summary: '主教练在赛前发布会上表示球队已经做好充分准备...'
        },
        {
          title: '多特蒙德客场战绩出色，有望爆冷',
          time: '4小时前',
          summary: '多特蒙德本赛季客场表现强势，面对强敌依然充满信心...'
        },
        {
          title: '德甲积分榜：两队仅差3分',
          time: '6小时前',
          summary: '联赛还剩6轮，两队积分非常接近，本场比赛至关重要...'
        }
      ]
    },
    {
      id: 102,
      title: '热刺 vs 阿森纳',
      category: '足球',
      league: '英超',
      status: 'upcoming',
      time: '今天 23:00',
      date: new Date().toLocaleDateString('zh-CN'),
      venue: '温布利球场',
      capacity: '90,000',
      importance: 'high',
      description: '北伦敦德比大战，两队历史交锋激烈，本场比赛关系到欧冠资格争夺。这是英超最具观赏性的德比之一。',
      homeTeam: '托特纳姆热刺',
      awayTeam: '阿森纳',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Tottenham%20vs%20Arsenal%20North%20London%20Derby%20football%20match%20stadium%20intense%20atmosphere%20with%20passionate%20fans&width=800&height=400&seq=matchdetail102&orientation=landscape',
      referee: '迈克尔·迪恩',
      weather: '多云，15°C',
      tickets: '少量余票',
      ticketPrice: '£35-£120',
      broadcastInfo: {
        tv: ['Sky Sports', 'NBC Sports', '腾讯体育'],
        streaming: ['Sky Go', 'NBC Sports App', '腾讯视频']
      },
      predictions: {
        homeWin: 35,
        draw: 35,
        awayWin: 30
      },
      recentForm: {
        home: ['胜', '平', '负', '胜', '胜'],
        away: ['胜', '胜', '胜', '平', '负']
      },
      headToHead: '近5次交锋：热刺 1胜2平2负 阿森纳',
      keyPlayers: {
        home: [
          { name: '凯恩', position: '前锋', goals: 22, assists: 5 },
          { name: '孙兴慜', position: '边锋', goals: 18, assists: 7 },
          { name: '洛里', position: '门将', saves: 76, cleanSheets: 12 }
        ],
        away: [
          { name: '萨卡', position: '边锋', goals: 14, assists: 11 },
          { name: '厄德高', position: '中场', goals: 7, assists: 9 },
          { name: '拉姆斯代尔', position: '门将', saves: 82, cleanSheets: 14 }
        ]
      },
      teamStats: {
        home: {
          formation: '3-4-3',
          possession: 54,
          shots: 15.6,
          corners: 5.2,
          fouls: 10.8,
          cards: { yellow: 1.9, red: 0.1 }
        },
        away: {
          formation: '4-3-3',
          possession: 56,
          shots: 14.4,
          corners: 6.1,
          fouls: 11.7,
          cards: { yellow: 2.2, red: 0.1 }
        }
      },
      injuries: {
        home: [],
        away: [
          { name: '帕蒂', injury: '脚踝伤势', status: '确定缺席' }
        ]
      },
      news: [
        {
          title: '孔蒂：北伦敦德比永远特殊',
          time: '1小时前',
          summary: '热刺主帅强调德比的重要性，球队会全力以赴...'
        },
        {
          title: '阿尔特塔：客场作战不会改变我们的踢法',
          time: '3小时前',
          summary: '阿森纳主教练表示球队会坚持自己的战术风格...'
        }
      ]
    },
    {
      id: 103,
      title: '快船 vs 雄鹿',
      category: '篮球',
      league: 'NBA',
      status: 'upcoming',
      time: '明天 10:30',
      date: new Date(Date.now() + 86400000).toLocaleDateString('zh-CN'),
      venue: '加密货币网站竞技场',
      capacity: '19,068',
      importance: 'medium',
      description: 'NBA西部强队对阵东部劲旅，伦纳德回归后快船状态火热。',
      homeTeam: '洛杉矶快船',
      awayTeam: '密尔沃基雄鹿',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=LA%20Clippers%20vs%20Milwaukee%20Bucks%20NBA%20basketball%20game%20arena%20atmosphere%2C%20professional%20sports&width=800&height=400&seq=matchdetail103&orientation=landscape',
      referee: '托尼·布拉瑟斯',
      weather: '室内比赛',
      tickets: '有票',
      ticketPrice: '$45-$300',
      broadcastInfo: {
        tv: ['ESPN', 'TNT', '腾讯体育'],
        streaming: ['NBA League Pass', '腾讯视频']
      },
      predictions: {
        homeWin: 52,
        draw: 0,
        awayWin: 48
      },
      recentForm: {
        home: ['胜', '胜', '胜', '负', '胜'],
        away: ['胜', '负', '胜', '胜', '平']
      },
      headToHead: '近5次交锋：快船 3胜2负 雄鹿',
      keyPlayers: {
        home: [
          { name: '伦纳德', position: '前锋', goals: 26, assists: 5 },
          { name: '乔治', position: '前锋', goals: 24, assists: 6 },
          { name: '威斯布鲁克', position: '后卫', goals: 15, assists: 8 }
        ],
        away: [
          { name: '字母哥', position: '前锋', goals: 30, assists: 6 },
          { name: '霍勒迪', position: '后卫', goals: 19, assists: 7 },
          { name: '洛佩兹', position: '中锋', goals: 12, assists: 2 }
        ]
      },
      teamStats: {
        home: {
          formation: '攻守平衡',
          possession: 50,
          shots: 92.8,
          corners: 0,
          fouls: 19.5,
          cards: { yellow: 0, red: 0 }
        },
        away: {
          formation: '内线优势',
          possession: 50,
          shots: 89.2,
          corners: 0,
          fouls: 18.9,
          cards: { yellow: 0, red: 0 }
        }
      },
      injuries: {
        home: [],
        away: [
          { name: '克里斯·米德尔顿', injury: '膝盖伤势', status: '疑似' }
        ]
      },
      news: [
        {
          title: '伦纳德复出状态良好，快船信心十足',
          time: '3小时前',
          summary: '快船核心球员伤愈复出后表现出色，球队整体实力大幅提升...'
        },
        {
          title: '字母哥：我们会在客场打出自己的风格',
          time: '5小时前',
          summary: '雄鹿当家球星表示球队已经适应客场作战，会全力争胜...'
        }
      ]
    },
    {
      id: 104,
      title: '费德勒 vs 阿尔卡拉斯',
      category: '网球',
      league: 'ATP大师赛',
      status: 'upcoming',
      time: '明天 21:00',
      date: new Date(Date.now() + 86400000).toLocaleDateString('zh-CN'),
      venue: '印第安维尔斯',
      capacity: '16,100',
      importance: 'high',
      description: '网坛传奇对阵新生代球王，经验与活力的终极碰撞。',
      homeTeam: '费德勒',
      awayTeam: '阿尔卡拉斯',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Federer%20vs%20Alcaraz%20tennis%20match%20professional%20court%20atmosphere%2C%20ATP%20tournament&width=800&height=400&seq=matchdetail104&orientation=landscape',
      referee: '主裁判：卡洛斯·莫亚德斯',
      weather: '晴朗，26°C',
      tickets: '热售中',
      ticketPrice: '$80-$400',
      broadcastInfo: {
        tv: ['ESPN', 'Tennis Channel', 'CCTV5+'],
        streaming: ['ESPN+', 'Tennis TV', '腾讯视频']
      },
      predictions: {
        homeWin: 42,
        draw: 0,
        awayWin: 58
      },
      recentForm: {
        home: ['胜', '负', '胜', '胜', '负'],
        away: ['胜', '胜', '胜', '胜', '胜']
      },
      headToHead: '历史首次交锋',
      keyPlayers: {
        home: [
          { name: '费德勒', position: '单打', goals: 0, assists: 0 }
        ],
        away: [
          { name: '阿尔卡拉斯', position: '单打', goals: 0, assists: 0 }
        ]
      },
      teamStats: {
        home: {
          formation: '全场攻势',
          possession: 0,
          shots: 0,
          corners: 0,
          fouls: 0,
          cards: { yellow: 0, red: 0 }
        },
        away: {
          formation: '底线进攻',
          possession: 0,
          shots: 0,
          corners: 0,
          fouls: 0,
          cards: { yellow: 0, red: 0 }
        }
      },
      injuries: {
        home: [],
        away: []
      },
      news: [
        {
          title: '费德勒：很高兴能与年轻才俊交手',
          time: '4小时前',
          summary: '瑞士天王表示期待与西班牙新星的对决，这将是一场精彩的比赛...'
        },
        {
          title: '阿尔卡拉斯：向传奇学习是我的荣幸',
          time: '6小时前',
          summary: '年轻的西班牙球员表达了对费德勒的敬意，同时也展现出必胜的决心...'
        }
      ]
    },
    {
      id: 105,
      title: '中国 vs 韩国',
      category: '乒乓球',
      league: 'WTT大满贯',
      status: 'upcoming',
      time: '后天 15:00',
      date: new Date(Date.now() + 172800000).toLocaleDateString('zh-CN'),
      venue: '新加坡体育馆',
      capacity: '12,000',
      importance: 'high',
      description: '亚洲乒乓球巅峰对决，两国顶尖选手将展开激烈争夺。',
      homeTeam: '中国队',
      awayTeam: '韩国队',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=China%20vs%20Korea%20table%20tennis%20match%20WTT%20tournament%20professional%20sports%20arena&width=800&height=400&seq=matchdetail105&orientation=landscape',
      referee: '国际级裁判团',
      weather: '室内比赛',
      tickets: '火热售票中',
      ticketPrice: 'S$50-S$200',
      broadcastInfo: {
        tv: ['CCTV5', 'KBS Sports', '新加坡体育频道'],
        streaming: ['央视频', 'KBS Play', 'WTT Live']
      },
      predictions: {
        homeWin: 70,
        draw: 0,
        awayWin: 30
      },
      recentForm: {
        home: ['胜', '胜', '胜', '胜', '胜'],
        away: ['胜', '胜', '负', '胜', '负']
      },
      headToHead: '近5次交锋：中国 4胜1负 韩国',
      keyPlayers: {
        home: [
          { name: '马龙', position: '男单', goals: 0, assists: 0 },
          { name: '樊振东', position: '男单', goals: 0, assists: 0 },
          { name: '王楚钦', position: '男单', goals: 0, assists: 0 }
        ],
        away: [
          { name: '林钟勋', position: '男单', goals: 0, assists: 0 },
          { name: '张禹珍', position: '男单', goals: 0, assists: 0 },
          { name: '安宰贤', position: '男单', goals: 0, assists: 0 }
        ]
      },
      teamStats: {
        home: {
          formation: '快攻弧圈',
          possession: 0,
          shots: 0,
          corners: 0,
          fouls: 0,
          cards: { yellow: 0, red: 0 }
        },
        away: {
          formation: '防守反击',
          possession: 0,
          shots: 0,
          corners: 0,
          fouls: 0,
          cards: { yellow: 0, red: 0 }
        }
      },
      injuries: {
        home: [],
        away: []
      },
      news: [
        {
          title: '马龙状态回升，中国队信心满满',
          time: '5小时前',
          summary: '龙队在训练中表现出色，为即将到来的比赛做好了充分准备...'
        },
        {
          title: '韩国队誓言要在新加坡创造奇迹',
          time: '7小时前',
          summary: '韩国队主教练表示球队已经制定了针对性战术，力争取得好成绩...'
        }
      ]
    },
    {
      id: 106,
      title: '巴西 vs 意大利',
      category: '排球',
      league: '国家联赛',
      status: 'upcoming',
      time: '后天 19:30',
      date: new Date(Date.now() + 172800000).toLocaleDateString('zh-CN'),
      venue: '里约热内卢',
      capacity: '11,800',
      importance: 'medium',
      description: '排球强国对决，巴西主场迎战意大利，精彩程度值得期待。',
      homeTeam: '巴西',
      awayTeam: '意大利',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Brazil%20vs%20Italy%20volleyball%20match%20national%20league%20professional%20sports%20arena%20Rio&width=800&height=400&seq=matchdetail106&orientation=landscape',
      referee: '国际排联裁判',
      weather: '室内比赛',
      tickets: '售票中',
      ticketPrice: 'R$30-R$150',
      broadcastInfo: {
        tv: ['SporTV', 'RAI Sport', 'CCTV5+'],
        streaming: ['Globoplay', 'RAI Play', '央视频']
      },
      predictions: {
        homeWin: 55,
        draw: 0,
        awayWin: 45
      },
      recentForm: {
        home: ['胜', '胜', '负', '胜', '胜'],
        away: ['胜', '负', '胜', '胜', '胜']
      },
      headToHead: '近5次交锋：巴西 3胜2负 意大利',
      keyPlayers: {
        home: [
          { name: '加比', position: '主攻', goals: 0, assists: 0 },
          { name: '卢卡斯', position: '副攻', goals: 0, assists: 0 },
          { name: '布鲁诺', position: '二传', goals: 0, assists: 0 }
        ],
        away: [
          { name: '朱塞佩', position: '主攻', goals: 0, assists: 0 },
          { name: '米歇兰杰洛', position: '副攻', goals: 0, assists: 0 },
          { name: '亚历山德罗', position: '二传', goals: 0, assists: 0 }
        ]
      },
      teamStats: {
        home: {
          formation: '攻守平衡',
          possession: 0,
          shots: 0,
          corners: 0,
          fouls: 0,
          cards: { yellow: 0, red: 0 }
        },
        away: {
          formation: '快速进攻',
          possession: 0,
          shots: 0,
          corners: 0,
          fouls: 0,
          cards: { yellow: 0, red: 0 }
        }
      },
      injuries: {
        home: [],
        away: []
      },
      news: [
        {
          title: '巴西队主场氛围浓厚，球迷热情高涨',
          time: '6小时前',
          summary: '里约热内卢的球迷已经开始为比赛造势，主场氛围将成为巴西队的优势...'
        },
        {
          title: '意大利队客场作战经验丰富',
          time: '8小时前',
          summary: '意大利队在客场比赛中表现稳定，教练组对球队实力充满信心...'
        }
      ]
    }
  ];

  useEffect(() => {
    // 根据ID查找对应的比赛数据
    const foundMatch = extendedMatches.find(m => m.id === parseInt(id || '0'));
    console.log('通过路由状态传递的比赛数据:',location.state, window.history.state.usr);
    let foundPost = null;
    if (location.state && location.state.match) {
      foundPost = location.state.match;
    } else if (window.history.state && window.history.state.usr && window.history.state.usr.match) {
      foundPost = window.history.state.usr.match;
    }
    if (foundPost) {
      setMatch(foundPost)
    };
    if (foundMatch) {
      // setMatch(foundMatch);
    } else {
      // 如果没找到，跳转回赛事列表页
      // navigate('/matches');
    }
  }, [id, navigate]);

  if (!match) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
            <i className="ri-football-line text-gray-400 text-2xl"></i>
          </div>
          <p className="text-gray-600">加载中...</p>
        </div>
      </div>
    );
  }

  // 设置提醒功能
  const handleSetReminder = () => {
    setShowSetReminder(true);
    setTimeout(() => {
      setShowSetReminder(false);
    }, 2000);
  };

  // 处理收藏功能
  const handleFavorite = (match: any) => {
    console.log('收藏比赛:', match);
    // 这里可以添加收藏逻辑
  };

  // 处理分享功能
  const handleShare = (match: any) => {
    if (navigator.share) {
      navigator.share({
        title: match?.title,
        text: `观看${match?.title} - ${match?.league}`,
        url: window.location.href
      }).catch(console.error);
    } else {
      // 复制链接到剪贴板
      navigator.clipboard.writeText(window.location.href).then(() => {
        alert('链接已复制到剪贴板');
      }).catch(() => {
        alert('分享失败，请手动复制链接');
      });
    }
  };
  const matchStatus = match?.state === 0 ? '未开始' : match?.state === 1 ? '进行中' : '已结束';
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
        {/* 比赛头部横幅 - 手机端优化 */}
        <section className="relative">
          <img
            src={match?.thumbnail|| defaultThumbnail }
            alt={match?.title}
            className="w-full h-60 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
          
          {/* 返回按钮 - 手机端优化 */}
          <div className="absolute top-4 left-4 md:top-6 md:left-6">
            <button
              onClick={() => navigate('/matches')}
              className="flex items-center px-3 py-2 md:px-4 md:py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg hover:bg-white/30 transition-colors cursor-pointer text-sm"
            >
              <i className="ri-arrow-left-line mr-1 md:mr-2"></i>
              <span className="hidden sm:inline">返回赛事列表</span>
              <span className="sm:hidden">返回</span>
            </button>
          </div>
          
          {/* 比赛基本信息 - 手机端优化 */}
          <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-6 text-white">
            <div className="container mx-auto">
              <div className="flex items-center flex-wrap gap-2">
                <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs font-medium bg-green-500">
                  {match?.category.name}
                </span>
                <span className="text-sm md:text-lg opacity-90">{match?.league_name}</span>
                {match?.importance === 'high' && (
                  <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs font-medium bg-red-500">
                    <i className="ri-fire-line mr-1"></i>
                    热门
                  </span>
                )}
              </div>
              
               {/* Match Basic Info */}
              <div className="p-4">
                <div className="grid grid-cols-3 items-center text-center">
                  <div className="flex flex-col items-center space-y-2">
                    {match?.home_logo && <img src={match?.home_logo} alt={match?.home} className="w-16 h-16 md:w-20 md:h-20 object-contain" />}
                    <h2 className="font-semibold text-base md:text-lg text-white">{match?.home || '主队'}</h2>
                  </div>
                  
                  <div className="flex flex-col items-center">
                    <div className="text-2xl md:text-4xl font-bold text-white">
                      {match?.state === 1 ? `${match?.home_score ?? 0} - ${match?.away_score ?? 0}` : 'VS'}
                    </div>
                    <span className={`mt-2 px-3 py-1 text-xs md:text-sm rounded-full ${
                      match?.state === 0 ? 'bg-gray-200 text-gray-800' :
                      match?.state === 1 ? 'bg-red-500 text-white animate-pulse' :
                      'bg-blue-100 text-blue-800'
                    }`}>
                      {matchStatus}
                    </span>
                  </div>

                  <div className="flex flex-col items-center space-y-2">
                    {match?.away_logo && <img src={match?.away_logo} alt={match?.away} className="w-16 h-16 md:w-20 md:h-20 object-contain" />}
                    <h2 className="font-semibold text-base md:text-lg text-white">{match?.away || '客队'}</h2>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-lg md:text-xl"></i>
                  <div>
                    <p className="text-xs md:text-sm opacity-75">比赛时间</p>
                    <p className="text-sm md:text-lg font-semibold">{new Date(match?.start_time).toLocaleString()}</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-lg md:text-xl"></i>
                  <div>
                    <p className="text-xs md:text-sm opacity-75">比赛场地</p>
                    <p className="text-sm md:text-lg font-semibold truncate">{match?.venue}</p>
                  </div>
                </div>
                
                <div className="flex items-center sm:col-span-2 md:col-span-1">
                  <i className="ri-ticket-line mr-2 text-lg md:text-xl"></i>
                  <div>
                    <p className="text-xs md:text-sm opacity-75">购票状态</p>
                    <p className={`text-sm md:text-lg font-semibold ${
                      match?.tickets === '已售罄' ? 'text-red-300' :
                      match?.tickets === '少量余票' ? 'text-yellow-300' :
                      'text-green-300'
                    }`}>{match?.tickets}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 快捷操作栏 - 手机端优化 */}
        <section className="bg-white border-b border-gray-200 sticky top-0 z-40">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between py-3 md:py-4">
              {/* 标签页导航 - 手机端横向滚动 */}
              <div className="flex items-center space-x-2 md:space-x-6 overflow-x-auto scrollbar-hide pb-2 md:pb-0 mb-3 md:mb-0">
                <button
                  onClick={() => setActiveTab('overview')}
                  className={`px-3 py-2 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    activeTab === 'overview'
                      ? 'bg-green-100 text-green-700'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  比赛概况
                </button>
                <button
                  onClick={() => setActiveTab('teams')}
                  className={`px-3 py-2 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    activeTab === 'teams'
                      ? 'bg-green-100 text-green-700'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  球队数据
                </button>
                <button
                  onClick={() => setActiveTab('players')}
                  className={`px-3 py-2 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    activeTab === 'players'
                      ? 'bg-green-100 text-green-700'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  球员信息
                </button>
                <button
                  onClick={() => setActiveTab('news')}
                  className={`px-3 py-2 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    activeTab === 'news'
                      ? 'bg-green-100 text-green-700'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  相关资讯
                </button>
              </div>
              
              {/* 操作按钮 - 手机端优化 */}
              <div className="flex items-center space-x-2 md:space-x-3">
                <Button
                  variant="outline"
                  onClick={handleSetReminder}
                  className="text-xs px-3 py-2 md:px-4 md:py-2 flex-1 md:flex-none whitespace-nowrap"
                >
                  <i className="ri-notification-line mr-1"></i>
                  <span className="hidden sm:inline">{showSetReminder ? '已设置!' : '设置提醒'}</span>
                  <span className="sm:hidden">{showSetReminder ? '已设!' : '提醒'}</span>
                </Button>
                <Button 
                  className="text-xs px-3 py-2 md:px-4 md:py-2 flex-1 md:flex-none whitespace-nowrap"
                  onClick={() => {
                    if (match?.tickets === '已售罄') {
                      // alert('票已售完，已为您加入候补名单');
                    } else {
                      // alert('正在跳转到购票页面...');
                    }
                  }}
                >
                  <i className="ri-ticket-line mr-1"></i>
                  <span className="hidden sm:inline">
                    {match?.tickets === '已售罄' ? '候补购票' : '立即购票'}
                  </span>
                  <span className="sm:hidden">
                    {match?.tickets === '已售罄' ? '候补' : '购票'}
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* 主要内容区域 - 手机端优化 */}
        <section className="py-4 md:py-8">
          <div className="container mx-auto px-4">
            {/* 比赛概况 */}
            {activeTab === 'overview' && (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-8">
                <div className="lg:col-span-2 space-y-4 md:space-y-8">
                  {/* 对阵双方 - 手机端优化 */}
                  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 md:mb-6 flex items-center">
                      <i className="ri-shield-line mr-2 text-green-600"></i>
                      对阵双方
                    </h2>
                    
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-gradient-to-r from-blue-50 via-gray-50 to-red-50 rounded-xl p-4 md:p-8 space-y-4 md:space-y-0">
                      <div className="text-center flex flex-col items-center flex-1">
                        {/* <div className="w-16 h-16 md:w-20 md:h-20 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                          <span className="text-white font-bold text-lg md:text-2xl">
                            {match?.home.charAt(0)}
                          </span>
                        </div> */}
                        {match.home_logo ? (
                        <img src={match.home_logo} alt={match.home} className="w-16 h-16 rounded-full object-contain " />
                          ) : (
                              <div className="w-16 h-16 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-xl ">
                                  <span className="text-white font-bold text-lg md:text-2xl">
                                    {match?.home.charAt(0)}
                                  </span>
                              </div>
                          )}
                        <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">{match?.home}</h3>
                        <p className="text-xs md:text-sm text-gray-500 mb-2">主场</p>
                        {match?.recentForm&&<div className="flex justify-center space-x-1">
                          {match?.recentForm.home.map((result: string, index: number) => (
                            <span
                              key={index}
                              className={`w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center text-xs font-medium text-white ${
                                result === '胜' ? 'bg-green-500' :
                                result === '平' ? 'bg-gray-500' :
                                'bg-red-500'
                              }`}
                            >
                              {result}
                            </span>
                          ))}
                        </div>}
                      </div>
                      
                      <div className="px-4 md:px-8 text-center">
                        <div className="text-2xl md:text-4xl font-bold text-gray-400 mb-1 md:mb-2">VS</div>
                        <div className="text-lg md:text-2xl font-bold text-green-600">{match?.start_time.split(' ')[1]}</div>
                        <div className="text-xs md:text-sm text-gray-500">{match?.date}</div>
                      </div>
                      
                      <div className="text-center flex flex-col items-center flex-1">
                        {/* <div className="w-16 h-16 md:w-20 md:h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                          <span className="text-white font-bold text-lg md:text-2xl">
                            {match?.awayTeam.charAt(0)}
                          </span>
                        </div> */}
                        {match.away_logo ? (
                        <img src={match.away_logo} alt={match.away} className="w-16 h-16 rounded-full object-contain" />
                          ) : (
                              <div className="w-16 h-16 rounded-full bg-red-500 text-white flex items-center justify-center font-bold text-xl">
                                  {match.away?.charAt(0)}
                              </div>
                          )}
                        <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">{match?.away}</h3>
                        <p className="text-xs md:text-sm text-gray-500 mb-2">客场</p>
                        {match?.recentForm&&<div className="flex justify-center space-x-1">
                          {match?.recentForm.away.map((result: string, index: number) => (
                            <span
                              key={index}
                              className={`w-5 h-5 md:w-6 md:h-6 rounded-full flex items-center justify-center text-xs font-medium text-white ${
                                result === '胜' ? 'bg-green-500' :
                                result === '平' ? 'bg-gray-500' :
                                'bg-red-500'
                              }`}
                            >
                              {result}
                            </span>
                          ))}
                        </div>}
                      </div>
                    </div>
                    
                    {/* 比赛详情 - 手机端优化 */}
                    <div className="mt-6 md:mt-8">
                      <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-3 flex items-center">
                        <i className="ri-information-line mr-2 text-blue-500"></i>
                        比赛详情
                      </h3>
                      <p className="text-gray-700 leading-relaxed text-sm md:text-base">{match?.description}</p>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-4">
                        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                          <i className="ri-referee-line mr-3 text-gray-600 text-lg"></i>
                          <div>
                            <p className="text-xs text-gray-500">裁判</p>
                            <p className="font-medium text-sm">{match?.referee}</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                          <i className="ri-cloud-line mr-3 text-gray-600 text-lg"></i>
                          <div>
                            <p className="text-xs text-gray-500">天气</p>
                            <p className="font-medium text-sm">{match?.weather}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* 历史交锋 - 手机端优化 */}
                  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 flex items-center">
                      <i className="ri-history-line mr-2 text-green-600"></i>
                      历史交锋
                    </h2>
                    <p className="text-gray-700 font-medium text-center py-4 md:py-6 text-base md:text-lg">
                      {match?.headToHead}
                    </p>
                  </div>
                  
                  {/* 胜负预测 - 手机端优化 */}
                  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 flex items-center">
                      <i className="ri-pie-chart-line mr-2 text-green-600"></i>
                      胜负预测
                    </h2>
                    
                    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
                      <div className="text-center">
                        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-2">
                          <span className="text-blue-600 font-bold text-lg md:text-xl">{match?.predictions?.homeWin || 0}%</span>
                        </div>
                        <p className="text-sm text-gray-600">{match?.home}</p>
                      </div>
                      
                      <div className="text-center">
                        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-2">
                          <span className="text-gray-600 font-bold text-lg md:text-xl">{match?.predictions?.draw || 0}%</span>
                        </div>
                        <p className="text-sm text-gray-600">平局</p>
                      </div>
                      
                      <div className="text-center">
                        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-2">
                          <span className="text-red-600 font-bold text-lg md:text-xl">{match?.predictions?.awayWin || 0}%</span>
                        </div>
                        <p className="text-sm text-gray-600">{match?.away}</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* 伤病情况 - 手机端优化 */}
                  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 flex items-center">
                      <i className="ri-first-aid-kit-line mr-2 text-green-600"></i>
                      伤病情况
                    </h2>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                      <div>
                        <h3 className="text-base font-medium text-blue-600 mb-2">{match?.home}</h3>
                        {match?.injuries?.home?.length > 0 ? (
                          <ul className="space-y-2">
                            {match?.injuries.home.map((injury: any, index: number) => (
                              <li key={index} className="flex items-center justify-between p-2 bg-blue-50 rounded">
                                <span className="text-sm font-medium">{injury.name}</span>
                                <span className={`text-xs px-2 py-1 rounded ${
                                  injury.status === '确定缺席' 
                                    ? 'bg-red-100 text-red-800' 
                                    : 'bg-yellow-100 text-yellow-800'
                                }`}>
                                  {injury.status}
                                </span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-gray-500 text-sm">暂无伤病报告</p>
                        )}
                      </div>
                      
                      <div>
                        <h3 className="text-base font-medium text-red-600 mb-2">{match?.away}</h3>
                        {match?.injuries?.away?.length > 0 ? (
                          <ul className="space-y-2">
                            {match?.injuries.away.map((injury: any, index: number) => (
                              <li key={index} className="flex items-center justify-between p-2 bg-red-50 rounded">
                                <span className="text-sm font-medium">{injury.name}</span>
                                <span className={`text-xs px-2 py-1 rounded ${
                                  injury.status === '确定缺席' 
                                    ? 'bg-red-100 text-red-800' 
                                    : 'bg-yellow-100 text-yellow-800'
                                }`}>
                                  {injury.status}
                                </span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-gray-500 text-sm">暂无伤病报告</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* 右侧栏 - 手机端移到底部 */}
                <div className="space-y-4 md:space-y-6">
                  {/* 购票信息 - 手机端优化 */}
                  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 flex items-center">
                      <i className="ri-ticket-2-line mr-2 text-green-600"></i>
                      购票信息
                    </h2>
                    
                    <div className="space-y-3">
                      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                        <span className="text-gray-600 text-sm">可容纳观众</span>
                        <span className="font-medium">{match?.capacity}</span>
                      </div>
                      
                      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                        <span className="text-gray-600 text-sm">票价范围</span>
                        <span className="font-medium">{match?.ticketPrice}</span>
                      </div>
                      
                      <button 
                        className={`w-full py-3 rounded-lg font-medium transition-colors ${
                          match?.tickets === '已售罄' 
                            ? 'bg-red-100 text-red-700 cursor-not-allowed' 
                            : 'bg-green-600 text-white hover:bg-green-700'
                        }`}
                        onClick={() => {
                          if (match?.tickets === '已售罄') {
                            // alert('票已售完，已为您加入候补名单');
                          } else {
                            // alert('正在跳转到购票页面...');
                          }
                        }}
                        disabled={match?.tickets === '已售罄'}
                      >
                        {match?.tickets === '已售罄' ? '已售罄' : '立即购票'}
                      </button>
                    </div>
                  </div>
                  
                  {/* 直播频道 - 手机端优化 */}
                  <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                    <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 flex items-center">
                      <i className="ri-live-line mr-2 text-green-600"></i>
                      直播频道
                    </h2>
                    
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-sm font-medium text-gray-700 mb-2">电视台</h3>
                        <div className="flex flex-wrap gap-2">
                          {match?.broadcastInfo&&match?.broadcastInfo.tv.map((channel: string, index: number) => (
                            <span 
                              key={index} 
                              className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs"
                            >
                              {channel}
                            </span>
                          ))}
                        </div>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-medium text-gray-700 mb-2">流媒体平台</h3>
                        <div className="flex flex-wrap gap-2">
                          {match?.broadcastInfo&&match?.broadcastInfo.streaming.map((platform: string, index: number) => (
                            <span 
                              key={index} 
                              className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-xs"
                            >
                              {platform}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 球队数据标签页 - 手机端优化 */}
            {activeTab === 'teams' && (
              <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 md:mb-6 flex items-center">
                  <i className="ri-bar-chart-line mr-2 text-green-600"></i>
                  球队数据对比
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                  <div className="space-y-4 md:space-y-6">
                    <h3 className="text-base md:text-lg font-semibold text-blue-600">{match?.home}</h3>
                    <div className="space-y-3 md:space-y-4">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">惯用阵型</span>
                        <span className="font-medium text-sm">{match?.teamStats?.home?.formation}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">平均控球率</span>
                        <span className="font-medium text-sm">{match?.teamStats?.home?.possession}%</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均射门</span>
                        <span className="font-medium text-sm">{match?.teamStats?.home?.shots}次</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均角球</span>
                        <span className="font-medium text-sm">{match?.teamStats?.home?.corners}次</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均犯规</span>
                        <span className="font-medium text-sm">{match?.teamStats?.home?.fouls}次</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均黄牌</span>
                        <span className="font-medium text-sm">{match?.teamStats?.home?.cards?.yellow}张</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="space-y-4 md:space-y-6">
                    <h3 className="text-base md:text-lg font-semibold text-red-600">{match?.away}</h3>
                    <div className="space-y-3 md:space-y-4">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">惯用阵型</span>
                        <span className="font-medium text-sm">{match?.teamStats?.away?.formation}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">平均控球率</span>
                        <span className="font-medium text-sm">{match?.teamStats?.away?.possession}%</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均射门</span>
                        <span className="font-medium text-sm">{match?.teamStats?.away?.shots}次</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均角球</span>
                        <span className="font-medium text-sm">{match?.teamStats?.away?.corners}次</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均犯规</span>
                        <span className="font-medium text-sm">{match?.teamStats?.away?.fouls}次</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 text-sm">场均黄牌</span>
                        <span className="font-medium text-sm">{match?.teamStats?.away?.cards?.yellow}张</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 球员信息标签页 - 手机端优化 */}
            {activeTab === 'players' && (
              <div className="space-y-6 md:space-y-8">
                <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                  <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 md:mb-6 flex items-center">
                    <i className="ri-user-star-line mr-2 text-green-600"></i>
                    关键球员
                  </h2>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    <div>
                      <h3 className="text-base md:text-lg font-semibold text-blue-600 mb-3 md:mb-4">{match?.home}</h3>
                      <div className="space-y-3 md:space-y-4">
                        {match?.keyPlayers&&match?.keyPlayers.home.map((player: any, index: number) => (
                          <div key={index} className="flex items-center p-3 md:p-4 bg-blue-50 rounded-lg">
                            <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-500 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                              <span className="text-white font-bold text-sm md:text-base">{player.name.charAt(0)}</span>
                            </div>
                            <div className="flex-1 min-w-0">
                              <h4 className="font-medium text-gray-900 text-sm md:text-base truncate">{player.name}</h4>
                              <p className="text-xs md:text-sm text-gray-600">{player.position}</p>
                              <div className="flex flex-wrap gap-2 md:gap-4 mt-1">
                                <span className="text-xs text-gray-500">进球: {player.goals}</span>
                                <span className="text-xs text-gray-500">助攻: {player.assists}</span>
                                {player.saves && <span className="text-xs text-gray-500">扑救: {player.saves}</span>}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-base md:text-lg font-semibold text-red-600 mb-3 md:mb-4">{match?.away}</h3>
                      <div className="space-y-3 md:space-y-4">
                        {match?.keyPlayers&& match?.keyPlayers.away.map((player: any, index: number) => (
                          <div key={index} className="flex items-center p-3 md:p-4 bg-red-50 rounded-lg">
                            <div className="w-10 h-10 md:w-12 md:h-12 bg-red-500 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                              <span className="text-white font-bold text-sm md:text-base">{player.name.charAt(0)}</span>
                            </div>
                            <div className="flex-1 min-w-0">
                              <h4 className="font-medium text-gray-900 text-sm md:text-base truncate">{player.name}</h4>
                              <p className="text-xs md:text-sm text-gray-600">{player.position}</p>
                              <div className="flex flex-wrap gap-2 md:gap-4 mt-1">
                                <span className="text-xs text-gray-500">进球: {player.goals}</span>
                                <span className="text-xs text-gray-500">助攻: {player.assists}</span>
                                {player.saves && <span className="text-xs text-gray-500">扑救: {player.saves}</span>}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 相关资讯标签页 - 手机端优化 */}
            {activeTab === 'news' && (
              <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
                <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-4 md:mb-6 flex items-center">
                  <i className="ri-newspaper-line mr-2 text-green-600"></i>
                  相关资讯
                </h2>
                
                <div className="space-y-4 md:space-y-6">
                  {match?.news&&match?.news.map((newsItem: any, index: number) => (
                    <article key={index} className="border-b border-gray-100 pb-4 md:pb-6 last:border-b-0">
                      <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-2">
                        <h3 className="text-base md:text-lg font-medium text-gray-900 hover:text-green-600 cursor-pointer mb-1 md:mb-0 pr-0 md:pr-4 leading-tight">
                          {newsItem.title}
                        </h3>
                        <span className="text-xs md:text-sm text-gray-500 whitespace-nowrap">{newsItem.time}</span>
                      </div>
                      <p className="text-gray-600 leading-relaxed text-sm md:text-base">{newsItem.summary}</p>
                      <button className="text-green-600 text-sm mt-2 hover:text-green-700 cursor-pointer">
                        阅读全文 →
                      </button>
                    </article>
                  ))}
                </div>
              </div>
            )}

            {/* 底部控制区域 */}
            <div className="p-4 bg-gray-50 border-t">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <button 
                    onClick={() => handleFavorite(match)}
                    className="flex items-center space-x-1 text-gray-600 hover:text-red-500 cursor-pointer transition-colors whitespace-nowrap"
                  >
                    <i className="ri-heart-line text-lg"></i>
                    <span className="text-sm">收藏</span>
                  </button>
                  <button 
                    onClick={() => handleShare(match)}
                    className="flex items-center space-x-1 text-gray-600 hover:text-blue-500 cursor-pointer transition-colors whitespace-nowrap"
                  >
                    <i className="ri-share-line text-lg"></i>
                    <span className="text-sm">分享</span>
                  </button>
                  <button className="flex items-center space-x-1 text-gray-600 hover:text-green-500 cursor-pointer transition-colors whitespace-nowrap">
                    <i className="ri-calendar-event-line text-lg"></i>
                    <span className="text-sm">日程</span>
                  </button>
                </div>
                
                <div className="flex items-center space-x-2">
                  <button className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors cursor-pointer text-sm whitespace-nowrap">
                    详细统计
                  </button>
                  <button className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors cursor-pointer text-sm whitespace-nowrap">
                    相关新闻
                  </button>
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}
